import Icon from 'veui/components/Icon'
import { IconSort } from 'dls-icons-vue'

Icon.register('sort', IconSort)
